export default from './breadcrumbs-widget';



// WEBPACK FOOTER //
// ./app/containers/breadcrumbs-widget/index.js